/* eslint-disable array-callback-return */
import homeModule from '../modules/home'
import get from 'lodash/get'
import size from 'lodash/size'
import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import Toastify from 'buddy-glud-component/lib/Toastify'
import { fetchPOST, fetchGET } from '../api/fetchers'
import Loading from 'buddy-glud-component/lib/Loading'
import Confirm from 'buddy-glud-component/lib/Confirm'
import { cookieStorage, localStorage } from '../utils'

// Add 2024-08-14 savelogs login
import platform from 'platform'

const hostmain = process.env.REACT_APP_HOST || ''
const host = process.env.REACT_APP_SIT_HOST || ''
const endpoint = process.env.REACT_APP_ENDPOINT || ''

const getAuthUserAction = ({ params }) => {
  return async (dispatch, getState) => {
    try {
      Loading.open({ label: 'กำลังตรวจสอบข้อมูล' })
      const response = await fetchGET({
        useMock: false,
        jsonMock: ``,
        url: `${host}${endpoint}/api/authen/user-info${params}`
      })
      
      if (isUndefined(response)) return
      const isSuccess = get(response, 'data.success', false)

      if (isSuccess) {
        const userInfo = { ...get(response, 'data.data', {}) }
        // console.log(`getAuthUserAction userInfo : `, userInfo);

        const activeCode = cookieStorage.get('SPACTIVECODE') ? JSON.parse(cookieStorage.get('SPACTIVECODE'))
              : {
                salesmancode: userInfo.salesmancode,
                divisionsales: userInfo.divisionsales,
                warehousecode: userInfo.warehousecode,
                active_salescode: ''
              }
        
        // console.log(`getAuthUserAction activeCode : `, activeCode);

        await dispatch(homeModule.setSaleInfo({
          data: {
            ...userInfo,
            orgcode: 'SPC',
            companycode: 'ALLINONE',
            salesmancode: activeCode.salesmancode,
            divisionsales: activeCode.divisionsales,
            warehousecode: activeCode.warehousecode,
            active_salescode: (!isEmpty(activeCode.active_salescode)) ? activeCode.active_salescode: activeCode.salesmancode
        } }))

        const { idtoken, ...expect } = userInfo
        cookieStorage.set({ cname: 'salesPlusSaleInfo', cvalue: JSON.stringify({
          ...expect,
          orgcode: 'SPC',
          companycode: 'ALLINONE'
        }) })
        cookieStorage.set({ cname: 'isLogin', cvalue: true, exdays: 1 })
        cookieStorage.set({ cname: 'xxopoc', cvalue: idtoken, exdays: 1 })
        
        if(size(userInfo.salesList) === 1 || userInfo.isSup === 'Y') dispatch(onGetMenuListAction())
        
        Loading.close()
        return true
      } else {

        setTimeout(() => {
          Confirm.open({
            title: 'ไม่สามารถเข้าระบบได้',
            content: get(response, 'data.message', 'เนื่องจากไม่พบข้อมูล'),
            closeButton: false,
            closeOnClickOutside: false,
            buttons: [
              {
                primary: true,
                label: 'ตกลง',
                onClick: null
              }
            ]
          })
        }, 300)
        Loading.close()
        return false
      }
    } catch (error) {
      console.log(error)
      setTimeout(() => {
        Confirm.open({
          title: 'ไม่สามารถเข้าระบบได้',
          content: error,
          closeButton: false,
          closeOnClickOutside: false,
          buttons: [
            {
              primary: true,
              label: 'ตกลง',
              onClick: null
            }
          ]
        })
      }, 300)
      return false
    }
  }
}

const getSaleInfoAction = () => {
  return async dispatch => {
    const userInfo = JSON.parse(cookieStorage.get('salesPlusSaleInfo'))
    let activeCode = cookieStorage.get('SPACTIVECODE') ? JSON.parse(cookieStorage.get('SPACTIVECODE'))
    : {
      salesmancode: userInfo.salesmancode,
      divisionsales: userInfo.divisionsales,
      warehousecode: userInfo.warehousecode,
      active_salescode: ''
    }

    if (userInfo.salesList.lenght === 1) {
      activeCode = userInfo.salesList[0]
    }

    await dispatch(homeModule.setSaleInfo({
      data: {
        ...userInfo,
        salesmancode: activeCode.salesmancode,
        divisionsales: activeCode.divisionsales,
        warehousecode: activeCode.warehousecode,
        active_salescode: activeCode.active_salescode
    } }))

    dispatch(onGetMenuListAction())
  }
}

const onLogoutAction = () => {
  return async (dispatch, getState) => {
    
    try {
      // Addons 2024-08-09 save login history ----
      const saleInfo = getState().home.saleInfo
      await navigator.geolocation.getCurrentPosition(async position => {
        const latitude = position.coords.latitude
        const longitude = position.coords.longitude

        let login_his = {
          orgcode: 'SPC',
          companycode: 'ALLINONE',
          empid: saleInfo.empid,
          userfullname: saleInfo.userfullname,
          salesmancode: saleInfo.salesmancode,
          divisionsales: saleInfo.divisionsales,
          warehousecode: saleInfo.warehousecode,
          latitude: latitude,
          longitude: longitude,
          deviceInfo: platform?.description,
          method: 'LOGOUT'
        }
  
        const ressave_his =  await fetchPOST({
          useMock: false,
          jsonMock: '',
          url: `${hostmain}/ebizapi_hwc/v3/salesplus/saveloginhistory`,
          // url: `https://spcuatws.sahapat.com/v3/salesplus/saveloginhistory`,
          data: login_his
        })
        // console.log(' Response save logs history : ',ressave_his)

      });
      // ----------------------------------------

      const response = await fetchPOST({
        useMock: false,
        jsonMock: ``,
        url: `${host}${endpoint}/api/authen/logout`,
        data: {
          redirectUri: encodeURIComponent(window.location.href),
          idtoken: cookieStorage.get('xxopoc')
        }
      })

      if (response?.data?.success) {
        cookieStorage.set({ cname: 'xxopoc', cvalue: '', exdays: -1 })
        cookieStorage.set({ cname: 'SPACTIVECODE', cvalue: '', exdays: -1 })
        cookieStorage.set({ cname: 'salesPlusSaleInfo', cvalue: '', exdays: -1 })
        localStorage.remove('salesPlusMenu')

        window.location.reload()
      }
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'ไม่สามารถทำรายการได้ กรุณาลองอีกครั้ง',
        closeTime: 3
      })
    }
  }
}

const onUpdateActiveSalesCodeAction = ({ active_salescode, divisionsales,  warehousecode}) => {
  return async (dispatch, getState) => {
    try {
      const saleInfo = getState().home.saleInfo
      
      dispatch(homeModule.setSaleInfo({
        data: {
          ...saleInfo,
          salesmancode: active_salescode,
          divisionsales: divisionsales,
          warehousecode: warehousecode,
          active_salescode: active_salescode
      } }))

      cookieStorage.set({
        cname: 'SPACTIVECODE',
        cvalue: JSON.stringify({
          salesmancode: active_salescode,
          divisionsales: divisionsales,
          warehousecode: warehousecode,
          active_salescode: active_salescode
        }),
        exdays: 1 })

        delete saleInfo.idtoken
        
        cookieStorage.set({ cname: 'salesPlusSaleInfo', cvalue: JSON.stringify({
          ...saleInfo,
          salesmancode: active_salescode,
          divisionsales: divisionsales,
          warehousecode: warehousecode,
          active_salescode: active_salescode
        }) })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'ไม่สามารถทำรายการได้ กรุณาลองอีกครั้ง',
        closeTime: 3
      })
    }
  }
}

const onGetMenuListAction = () => {
  return async (dispatch, getState) => {
    try {
      // Addons 2024-08-09 save login history ----
      const saleInfo = getState().home.saleInfo
      await navigator.geolocation.getCurrentPosition(async position => {
        const latitude = position.coords.latitude
        const longitude = position.coords.longitude

        let login_his = {
          orgcode: 'SPC',
          companycode: 'ALLINONE',
          empid: saleInfo.empid,
          userfullname: saleInfo.userfullname,
          salesmancode: saleInfo.salesmancode,
          divisionsales: saleInfo.divisionsales,
          warehousecode: saleInfo.warehousecode,
          latitude: latitude,
          longitude: longitude,
          deviceInfo: platform?.description,
          method: 'LOGIN'
        }
  
        const ressave_his =  await fetchPOST({
          useMock: false,
          jsonMock: '',
          url: `${hostmain}/ebizapi_hwc/v3/salesplus/saveloginhistory`,
          // url: `https://spcuatws.sahapat.com/v3/salesplus/saveloginhistory`,
          data: login_his
        })
        // console.log(' Response save logs history : ',ressave_his)
      });
      // ----------------------------------------

      let menulist = []
      if (localStorage.get('salesPlusMenu') !== null && !isEmpty(localStorage.get('salesPlusMenu')) && localStorage.get('salesPlusMenu') !== '[]') {
        menulist = JSON.parse(localStorage.get('salesPlusMenu'))
        
      } else {
        const menuResponse = await fetchPOST({
          useMock: false,
          jsonMock: ``,
          url: `${host}${endpoint}/api/authen/menu-list`,
          data: {
            empid: saleInfo.empid,
            salesmancode: saleInfo.salesmancode,
            system: 'salesplus'
          }
        })
  
        menulist = get(menuResponse, 'data.data', []).map(menu => {
          const { menuLevel, menuChlids } = menu
          let newMenuChilds = []
  
          if (menuLevel === '_group') {
            menuChlids.map(child => {
              newMenuChilds.push({
                ...child,
                menuParent: menu.menuLink
              })
            })
          }
  
          return {
            ...menu,
            menuChlids: newMenuChilds
          }
        })
  
        localStorage.set({ key: 'salesPlusMenu', value: JSON.stringify(menulist) })
      }

      dispatch(homeModule.setSaleInfo({
        data: {
          ...saleInfo,
          menulist
      } }))

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'ไม่สามารถทำรายการได้ กรุณาลองอีกครั้ง',
        closeTime: 3
      })
    }
  }
}

export {
  getAuthUserAction,
  onLogoutAction,
  onUpdateActiveSalesCodeAction,
  getSaleInfoAction,
  onGetMenuListAction }
